function initSearch() {
  const predictiveSearchInput = document.querySelector('.search__input');

  predictiveSearchInput.addEventListener('input', function() {
    if(predictiveSearchInput.value.length >= 3) {
      handleSearchInput(predictiveSearchInput.value)
    }
  })
}

function handleSearchInput(searchTerm) {
  const predictiveSearchSection = document.querySelector('.predictive-search-results');
  var requestResponse;

  let formattedSearchTerm = searchTerm.replace(" ", "+");
  
  fetch(window.Shopify.routes.root + "search/suggest?q=" + formattedSearchTerm + "&resources[type]=product,query,collection&resources[limit_scope]=each&resources[limit]=6&resources[options][unavailable_products]=hide&resources[options][fields]=title,tag,product_type,variants.title,vendor&section_id=predictive-search")
    .then((response) => {
      requestResponse = response;

      return response.text();
     })
    .then((text) => {
      if (!requestResponse.ok) {
        throw new Error(`${requestResponse.status}: ${text}`);
      }
  
      const resultsMarkup = new DOMParser()
        .parseFromString(text, 'text/html')
        .querySelector('#shopify-section-predictive-search').innerHTML;
  
      predictiveSearchSection.innerHTML = resultsMarkup;
    })
    .catch((error) => {
      console.error(error);
    });
}

document.addEventListener('DOMContentLoaded', initSearch());